import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import useFirestore from "../hooks/useFirestore";

const ImgGrid = styled.div`
  margin: 2rem auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; // 3 takie same kolumny
  grid-gap: 4rem; // odstępny między kolumnami
  justify-content: center;

  /* @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 4rem;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  } */
`;

const ImgWrap = styled(motion.div)`
  overflow: hidden;
  height: 0;
  padding: 50% 0;
  /* height: 30rem;
  width: 30rem;
  margin: 0 auto; */
  /* padding controls height, will always be perfectly square regardless of width */
  position: relative;
  opacity: 0.8;
  border-radius: 0.5rem;
`;

const ImgItem = styled(motion.img)`
  object-fit: cover;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;

  position: absolute;
  top: 0;
  left: 0;
`;

const ImageGrid = (props) => {
  const { docs } = useFirestore("images"); // hook useFiretore spodizewa sie arguemntu collectionName
  //   console.log(docs);
  return (
    <ImgGrid>
      {docs &&
        docs.map((doc) => (
          <ImgWrap
            onClick={() => props.setSelectedImg(doc.url)} // uzyj funkcji z App.js i przekaz doc.url z useFirebase
            key={doc.id}
            whileHover={{ opacity: 1 }}
            layout //! animuj po uploadzie
          >
            <ImgItem
              src={doc.url}
              alt="uploaded photo"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1 }}
            />
          </ImgWrap>
        ))}
    </ImgGrid>
  );
};

export default ImageGrid;
